module.exports = __webpack_public_path__ + "fonts/1463e6a.eot";